import React, { useEffect, useState } from 'react';

import './styles.css';

import close from '../../../assets/images/close.svg';
import clock from '../../../assets/images/clock.svg';
import user2 from '../../../assets/images/user2.svg';
import pin4 from '../../../assets/images/pin4.svg';
import moment from "moment";
import 'moment/locale/pt-br';
import api from '../../../services/api';

export const ModalTimeBrokers = ({ handleClose, corretoresAtivos, filter, regionName, plantoesName }) => {

  const [corretores, setCorretores] = useState([]);

  useEffect(() => {
    getCorretores();
  }, []);

  const getCorretores = async () => {
    const { data } = await api.get(`plantoes/corretores-ativos`, {
      params: filter
    });
    setCorretores(data.corretores);
  }
  return (
    <div className="dash-modal">
      <div className="dash-modal-content lg">
        <button className="btn-close" onClick={() => handleClose()}><img src={close} /></button>
        <div className="dash-modal-header header-modal-pages">
          <div>
            <img src={clock} />
            <h1>Tempo real</h1>
          </div>
          <div className="data-about">
            <img src={user2} />
            <h1 style={{ color: "#02C39A" }}>{corretoresAtivos}</h1>
            <p>Corretores nos plantões</p>
          </div>
        </div>
        <div className="box-modal-gray">
          <div className="box-gray-modals">
            <p>{regionName ?? "Brasil"}</p>
          </div>
          <div className="box-gray-modals">
            <img src={pin4} />
            <p>{plantoesName}</p>
          </div>
        </div>
        <div className="dash-modal-body">
          <div className="box-card h-full">
            <div className="box-card-noPadding box-table-shifts box-last-gray">
              <table className="table-dash">
                <thead>
                  <tr className="light-blue">
                    <th>Estado</th>
                    <th>Plantão</th>
                    <th>Corretor</th>
                    <th>Gerente</th>
                  </tr>
                </thead>
                <tbody>
                  {corretores.map((corretor, key) => (
                    <tr>
                      <td>{corretor.regional.slug}</td>
                      <td>{corretor.plantao.imovel_nome}</td>
                      <td>{corretor.apelido}</td>
                      <td>{corretor.gerente ? corretor.gerente.apelido : `-`}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="dash-modal-footer">

        </div>
      </div>
    </div>
  );

}

export default ModalTimeBrokers;